import { useCallback } from "react";
import { createExportedDocument } from "../services/school/student/createStudent";

export const useExportDocument = () => {
  const exportDocument = useCallback(async (templateData: any, filenamePrefix: string) => {
    try {
      const documentBlob: Blob = await createExportedDocument(templateData);
      const url = window.URL.createObjectURL(documentBlob);
      const link = document.createElement("a");
      const timestamp = new Date().getTime();
      link.href = url;
      link.download = `${filenamePrefix}_${timestamp}.docx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao exportar documento:", error);
      throw error; 
    }
  }, []);
  const downloadOnly = useCallback(async (documentBlob:any, filenamePrefix: string) => {
    try {
      const url = window.URL.createObjectURL(documentBlob);
      const link = document.createElement("a");
      const timestamp = new Date().getTime();
      link.href = url;
      link.download = filenamePrefix??`${filenamePrefix}_${timestamp}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw error; 
    }
  }, []);
  return {
    exportDocument,downloadOnly
  };
};
